export const addNote = {
    namespaced: true,

    state: {
        session: {
            id: null,
            date: null,
            name: ''
        },
        note: null
    },

    getters: {
        note(state) {
            return state.note;
        },

        session(state) {
            return state.session;
        }
    },

    mutations: {
        setSessionDetails(state, payload) {
            state.session = payload;
        },

        setNote(state, payload) {
            state.note = payload;
        },

        reset(state) {
            state.session = {
                id: null,
                date: null,
                name: ''
            };
            state.note = null;
        }
    }
};

export default addNote;
